import { useField } from 'formik';
import { FC, ReactNode } from 'react';
import { tw } from 'utils/tailwindUtils';

interface CheckboxFieldProps {
  label: ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

/** Checkbox presentacional con el estilo estándar (para valores no booleanos). */
export const CheckboxField: FC<CheckboxFieldProps> = ({
  label,
  checked,
  onChange,
  disabled,
  className
}) => (
  <label
    className={tw(
      'flex cursor-pointer items-center gap-2 text-sm text-ink dark:text-ink-dark',
      disabled && 'cursor-not-allowed opacity-60',
      className
    )}
  >
    <input
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onChange={(e) => onChange(e.target.checked)}
      className="h-4 w-4 accent-secondary-500"
    />
    {label}
  </label>
);

interface FormikCheckboxProps {
  name: string;
  label: ReactNode;
  disabled?: boolean;
  className?: string;
}

/** Checkbox de Formik para un campo booleano. */
const FormikCheckbox: FC<FormikCheckboxProps> = ({ name, ...rest }) => {
  const [field, , helpers] = useField<boolean | undefined>(name);

  return (
    <CheckboxField
      checked={!!field.value}
      onChange={(checked) => helpers.setValue(checked)}
      {...rest}
    />
  );
};

export default FormikCheckbox;
